/* @ngInject */
const go = (
  $state,
  $uibModal,
  trainLocal,
  trainData,
  routes,
  toaster,
  $$autocomplete,
  wagonData,
  wagonUtils
) => {
  const self = {}

  self.consult = (_id) => {
    trainLocal.saveCurrentId(_id)
    $state.go(routes.consult.train.details.path)
  }

  self.edit = (_id) => {
    trainLocal.saveCurrentId(_id)
    $state.go(routes.consult.train.edit.path)
  }

  self.addWagon = async (_train) => {
    trainLocal.saveCurrentId(_train)
    trainData.myTrain = _train

    try {
      const wagonIds = await $$autocomplete.request.get('id', 'wagons')

      $uibModal.open({
        template: require('./addWagon.html'),
        resolve: {
          train: () => {
            return _train
          },
          wagonIds: () => {
            return wagonIds
          },
        },
        /* @ngInject */
        controller: ($scope, $uibModalInstance, train, wagonIds, utils, $$wagon, $$train) => {
          $scope.train = train
          $scope.wagonIds = wagonIds
          $scope.utils = utils

          $scope.addWagon = async (_wagonId, _trainId) => {
            _wagonId = wagonUtils.stringToId(_wagonId)

            try {
              const message = await $$train.request.addWagon(_wagonId, _trainId)
              toaster.message(message)
              $scope.wagonId = null
              const wagon = await $$wagon.request.getById(_wagonId)
              $$wagon.data.myWagons.push(wagon)
              $uibModalInstance.close()
            } catch (error) {
              toaster.error(error)
            }
          }

          $scope.cancel = () => {
            $uibModalInstance.close()
          }

          $scope.valid = (_id) => {
            return wagonUtils.isIdValid(_id)
          }
        },
      })
    } catch (error) {

    }
  }

  self.removeWagon = (_train) => {
    // trainLocal.setCurrent(_train)
    trainData.myTrain = _train

    $uibModal.open({
      template: require('./removeWagon.html'),
      resolve: {
        train: () => {
          return _train
        },
        wagons: () => {
          return wagonData.myWagons
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        train,
        wagons,
        utils,
        trainLabels,
        $$train
      ) => {
        $scope.train = train
        $scope.wagons = wagons
        // $scope.selectedIds = []

        $scope.removeWagons = (_train, _wagonIds) => {
          $$train.request.removeWagons(_train.id, _wagonIds)
            .then((res) => {
              toaster.message(trainLabels.statements.wagonsRemoved(res.length))
              $scope.selectedIds.forEach(wagonId => {
                utils.removeFromArray(wagons, wagonId)
              })
              $uibModalInstance.close()
            })
            .catch((error) => {
              toaster.error(error)
            })
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/go.service.js